import { createContext, useContext, useState } from "react";

const Ctx = createContext(null);

export const DemoProvider = ({ children }) => {
  const [intent, setIntent] = useState("Meet people building something interesting");
  const [credits, setCredits] = useState(0);
  const addCredits = (n) => setCredits((c) => c + n);
  return <Ctx.Provider value={{ intent, setIntent, credits, addCredits }}>{children}</Ctx.Provider>;
};

export const useDemoState = () =>
  useContext(Ctx) || { intent: "", setIntent: () => {}, credits: 0, addCredits: () => {} };
